import {
	GuarantorEntityType,
	PatientEntityType,
	PractitionerEntityType,
} from "@/lib/supabase/supabaseTypes";
import { PdfLetterhead } from "../pdf-template-components/pdf-letterhead.component";
import { PdfLayout } from "../pdf-template-components/pdf-layout.component";
import { PdfRecipientAddress } from "../pdf-template-components/pdf-recipient-address.component";
import { QrPaymentSlip } from "../pdf-template-components/qr-payment-slip/qr-payment-slip.component";
import { PaymentSlipDataInput } from "../pdf-template-components/qr-payment-slip/qr-payment-helpers";
import "../fonts.css";
import { PdfTemplateType } from "../document-template.types";
import { PdfInvoiceBody } from "../pdf-template-components/pdf-invoice-body.component";
import { CommonPDFTemplateProps } from "./types";
import { PdfFooter } from "../pdf-template-components/pdf-footer.component";
import { PdfTaxAmountText } from "../pdf-template-components/pdf-tax-amount-text.component";
import { getRecipient } from "../utils";
import { useCurrencyHierarchy } from "../../lib/utils/region-utils";
export interface RechnungTemplateProps extends CommonPDFTemplateProps {
	patient?: PatientEntityType;
	guarantor?: GuarantorEntityType;
	practitioner?: PractitionerEntityType;
	paymentSlipData: PaymentSlipDataInput;
	noPaymentSlip?: boolean;
}

export const RechnungTemplate: React.FC<RechnungTemplateProps> = ({
	client,
	job,
	jobDocument,
	jobItems,
	organization,
	pdfTemplateConfiguration,
	currencyConverterValues,
	patient,
	guarantor,
	practitioner,
	paymentSlipData,
	jobTotals,
	noPaymentSlip,
}) => {
	const currency = useCurrencyHierarchy(job, client);
	if (
		!organization ||
		!pdfTemplateConfiguration ||
		!job ||
		!jobDocument ||
		!jobItems ||
		!client ||
		!paymentSlipData
	) {
		return null;
	}
	return (
		<PdfLayout pdfTemplateConfiguration={pdfTemplateConfiguration}>
			<PdfLetterhead
				organization={organization}
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				pdfType={PdfTemplateType.RECHNUNG}
				mwstNumber={
					job.mwst_number ??
					client.mwst_number ??
					organization.mwst_number ??
					""
				}
			/>
			<PdfRecipientAddress
				recipient={getRecipient({
					job,
					patient,
					guarantor,
					client,
					templateType: PdfTemplateType.RECHNUNG,
				})}
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				template={PdfTemplateType.RECHNUNG}
			/>
			<PdfInvoiceBody
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				title="Rechnung"
				client={client}
				job={job}
				jobDocument={jobDocument}
				jobItems={jobItems}
				patient={patient}
				practitioner={practitioner}
				paymentSlipData={paymentSlipData}
				organization={organization}
				jobTotals={jobTotals}
			/>
			<PdfTaxAmountText
				templateType={PdfTemplateType.RECHNUNG}
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				jobTotals={jobTotals}
				generalConfig={pdfTemplateConfiguration.general}
				client={client}
				currency={currency}
				style={{
					paddingLeft: "5mm",
					paddingRight: "10mm",
				}}
			/>
			<PdfFooter
				templateType={PdfTemplateType.RECHNUNG}
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				client={client}
				currencyConverterValues={currencyConverterValues}
			/>
			{!noPaymentSlip && (
				<QrPaymentSlip
					pdfTemplateConfiguration={pdfTemplateConfiguration}
					paymentSlipData={paymentSlipData}
					textAbove={
						pdfTemplateConfiguration[PdfTemplateType.RECHNUNG]
							.textAbovePaymentSlip
					}
				/>
			)}
		</PdfLayout>
	);
};
